module.exports = __webpack_public_path__ + "img/down.a69e5e6c.jpg";